import * as React from "react";
import { forwardRef } from "react";
const SvgSend = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.94608 9.31502C1.42408 9.14102 1.41908 8.86002 1.95608 8.68102L21.0441 2.32002C21.5731 2.14402 21.8761 2.44002 21.7281 2.95802L16.2741 22.044C16.1241 22.573 15.8191 22.591 15.5951 22.089L12.0001 14L18.0001 6.00002L10.0001 12L1.94608 9.31502Z", fill: "#5090EA" }));
const ForwardRef = forwardRef(SvgSend);
export { ForwardRef as ReactComponent };
